import EntryNotesSection from './EntryNotesSection';

export default EntryNotesSection;
